import { render, staticRenderFns } from "./BlockAudio.vue?vue&type=template&id=74836c6e&scoped=true"
import script from "./BlockAudio.vue?vue&type=script&lang=js"
export * from "./BlockAudio.vue?vue&type=script&lang=js"
import style0 from "./BlockAudio.vue?vue&type=style&index=0&id=74836c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74836c6e",
  null
  
)

export default component.exports